import { render, staticRenderFns } from "./CriterionOptionAccordion.vue?vue&type=template&id=95b53984&scoped=true&"
import script from "./CriterionOptionAccordion.vue?vue&type=script&lang=js&"
export * from "./CriterionOptionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CriterionOptionAccordion.vue?vue&type=style&index=0&id=95b53984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b53984",
  null
  
)

export default component.exports